<template>
  <div class="indicator"></div>
</template>

<style scoped lang="scss">
  @import './styles';
</style>
